export default __webpack_public_path__ + "static/media/pokesage.06d76646.gbc";